/**
 * BottomNav — mobile primary navigation (bottom tab bar).
 * Config-driven (see config/navigation.js), role-aware, permission-filtered.
 * Hidden on tablet/desktop (≥768px) where the top Header nav is used instead.
 */

import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.jsx';
import { getNavTabs, activeTabKey } from '../../config/navigation.js';
import GeIcon from '../common/GeIcon.jsx';
import './BottomNav.css';

function BottomNav() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  const tabs = isAuthenticated && user ? getNavTabs(user) : [];
  const shown = tabs.length > 0;

  // Flag on <body> so content padding + mobile header declutter apply only when
  // the bar is actually present (authenticated). Removed when it's not shown.
  useEffect(() => {
    document.body.classList.toggle('has-bottom-nav', shown);
    return () => document.body.classList.remove('has-bottom-nav');
  }, [shown]);

  if (!shown) return null;

  const active = activeTabKey(tabs, location.pathname);

  return (
    <nav className="bottom-nav" aria-label="Navigation principale">
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <Link
            key={t.key}
            to={t.to}
            className={`bn-tab${t.primary ? ' bn-primary' : ''}${isActive ? ' bn-active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            <span className="bn-icon" aria-hidden="true"><GeIcon name={t.icon} /></span>
            <span className="bn-label">{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}

export default BottomNav;
